import { Countries } from "./countries";

// then the list of countries gets added underneath.
export const listOfOperatingEntities = ["Automotive", "Group", "VOIS"];

export const allowedOperatingEntities = listOfOperatingEntities.concat(Countries.map(c => c.name));